import { useEffect } from 'react';
import { useFeatureFlags } from './useFeatureFlags';
import { flagsmithFeatureFlags } from '@/lib/flagsmith';

/**
 * Resolves the `mcp_gateway_control` flag for the Inventory MCP Servers tab
 * (KIR-3940). Fails closed on loading/error so the legacy column set is what
 * ever shows by default — never a flash of the gateway-control UI.
 */
export function useMcpGatewayControlEnabled(): boolean {
  const { flags, isLoading, isError } = useFeatureFlags([
    flagsmithFeatureFlags.MCP_GATEWAY_CONTROL,
  ]);

  useEffect(() => {
    if (isError) {
      console.error(
        '[useMcpGatewayControlEnabled] Failed to resolve mcp_gateway_control feature flag; defaulting to off'
      );
    }
  }, [isError]);

  if (isLoading || isError) {
    return false;
  }
  return flags[flagsmithFeatureFlags.MCP_GATEWAY_CONTROL] === true;
}
